import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
/**
 * ReceiptTotalStrikedThrough
 */
export const receiptTotalStrikedThroughStyles = ({ theme }) => css `
	&& {
		text-decoration: line-through;
		text-align: right;
		color: ${theme.colors.base.textPriceReceipt};
	}
`;
export const StyledReceiptTotalStrikedThrough = styled(Typography).attrs({
    variant: 'price-text-sm',
    tagName: 's',
}) `
	${receiptTotalStrikedThroughStyles}
`;
